(() => {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const initializeHoverMenus = () => {
    const menus = document.querySelectorAll(
      '.header__inline-menu header-menu > details'
    );

    menus.forEach((details) => {
      if (details.dataset.hoverMenuInitialized === 'true') {
        return;
      }

      details.dataset.hoverMenuInitialized = 'true';

      const summary = details.querySelector(':scope > summary');
      let closeTimer;

      const closeOtherMenus = () => {
        menus.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute('open');
          }
        });
      };

      const openMenu = () => {
        if (!desktopHover.matches) return;

        window.clearTimeout(closeTimer);
        closeOtherMenus();
        details.setAttribute('open', '');
      };

      const scheduleClose = () => {
        if (!desktopHover.matches) return;

        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 220);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);

      details.addEventListener('focusin', openMenu);

      details.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!details.contains(document.activeElement)) {
            scheduleClose();
          }
        }, 0);
      });

      summary?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          summary.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeHoverMenus,
      { once: true }
    );
  } else {
    initializeHoverMenus();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeHoverMenus
  );
})();